import Vue from 'vue';
import Router from 'vue-router';
/* Layout */
import Layout from '@/layout'

import Login from "@/pages/Login"; //登录页面

import Home from '@/pages/Home'; //主页
import MyApps from '@/pages/myApps/MyApps'; //我的应用
import MyAppsCenter from '@/pages/myApps/MyAppsCenter'; //应用中心
import MyAppsDetails from '@/pages/myApps/MyAppsDetails'; //应用详情
import MyAppsDetails2 from '@/pages/myApps/MyAppsDetails2.vue'; //应用详情

// 课程信息（学生端）
import MyCourse from '@/pages/course/MyCourse'; //我的课程
import CourseHome from '@/pages/course/CourseHome'; //课程首页
import ErrorSet from '@/pages/course/ErrorSet'; //错题集
import Exercises from '@/pages/course/Exercises'; //练习页面
import PracticeErrorTuckExercise from '@/pages/course/PracticeErrorTuckExercise'; //练习页面、错题集练习
import ExercisesDetails from '@/pages/course/ExercisesDetails'; //练习详情
import HomeworkStart from '@/pages/course/HomeworkStart'; //作业页面
import HomeworkDetails from '@/pages/course/HomeworkDetails'; //作业详情
import ExamListStart from '@/pages/course/ExamListStart'; //考试页面
import ExamListDetails from '@/pages/course/ExamListDetails'; //考试详情
import CourseCenter from '@/pages/course/CourseCenter'; //课程中心
import CourseFavorites from '@/pages/course/Favorites'; //我的收藏
import CoursewareViewing from '@/pages/course/CoursewareViewing'; //课件查看
import ScoreWeight from '@/pages/course/ScoreWeight'; //查看成绩权重
import TrainingIndex from '@/pages/course/TrainingIndex'; //开始实训
import DiscussionRecord from '@/pages/course/DiscussionRecord'; //查看历史讨论
import TaskExercises from '@/pages/course/TaskExercises'; //实训考试
import TaskExercisesDetails from '@/pages/course/TaskExercisesDetails'; //实训考试详情

// 课程信息（教师端）
import TCourseHome from '@/pages/Teacher/CourseHome'; //课程首页
import TMyCourse from '@/pages/Teacher/MyCourse'; //我的课程
import TErrorSet from '@/pages/Teacher/ErrorSet'; //错题集
import TExercises from '@/pages/Teacher/Exercises'; //练习页面
import TCourseFavorites from '@/pages/Teacher/Favorites'; //我的收藏
import TCoursewareViewing from '@/pages/Teacher/CoursewareViewing'; //课件查看
import TScoreWeight from '@/pages/Teacher/ScoreWeight'; //查看成绩权重
import TTrainingIndex from '@/pages/Teacher/TrainingIndex'; //开始实训
import TDiscussionRecord from '@/pages/Teacher/DiscussionRecord'; //查看历史讨论
import SignInDetails from '@/pages/Teacher/SignInDetails'; //签到详情
import ExerciseResults from '@/pages/Teacher/ExerciseResults'; //练习成绩
import ExerciseDetails from '@/pages/Teacher/ExerciseDetails'; //练习详情
import QuestionList from '@/pages/Teacher/QuestionList'; //试题管理
import ExportQuestion from '@/pages/Teacher/ExportQuestion'; //批量导入试题
import AddPractical from '@/pages/Teacher/AddPractical'; //新增实训
import Mp4Details from '@/pages/Teacher/Mp4Details'; //视频评分详情
import PPTDetails from '@/pages/Teacher/PPTDetails'; //PPT评分详情
import TheoryDetails from '@/pages/Teacher/TheoryDetails'; //基础知识评分详情
import PracticalDetails from '@/pages/Teacher/PracticalDetails'; //实操评分详情
import ReportDetails from '@/pages/Teacher/ReportDetails'; //撰写报告评分详情
import PracticalResults from '@/pages/Teacher/PracticalResults'; //实操成绩
import PracticalReview from '@/pages/Teacher/PracticalReview'; //评阅
import SeePractice from '@/pages/Teacher/SeePractice'; //查看实操
import SeePracticeDetails from '@/pages/Teacher/SeePracticeDetails'; //查看实操详情
import HomeworkScore from '@/pages/Teacher/HomeworkScore'; //查看作业成绩
import THomeworkDetails from '@/pages/Teacher/HomeworkDetails'; //作业详情
import HomeworkPracticalReview from '@/pages/Teacher/HomeworkPracticalReview'; //评阅作业
import HomeworkFJScore from '@/pages/Teacher/HomeworkFJScore'; //附件作业详情
import ExamListScore from '@/pages/Teacher/ExamListScore'; //查看考试成绩
import TExamListDetails from '@/pages/Teacher/ExamListDetails'; //考试详情

//课程中心进入课程信息预览
import LookCourseHome from '@/pages/lookCourse/CourseHome'; //课程首页
import LookExercises from '@/pages/lookCourse/Exercises'; //练习页面
import LookExercisesDetails from '@/pages/lookCourse/ExercisesDetails'; //练习详情
import LookExercisesCourse from '@/pages/lookCourse/ExercisesCourse'; //练习页面
import LookExercisesCourseDetails from '@/pages/lookCourse/ExercisesCourseDetails'; //练习详情
import LookTrainingIndex from '@/pages/lookCourse/TrainingIndex'; //开始实训
import LookTaskExercises from '@/pages/lookCourse/TaskExercises'; //实训考试
import LookTaskExercisesDetails from '@/pages/lookCourse/TaskExercisesDetails'; //实训考试详情
import LookTaskExercisesCourse from '@/pages/lookCourse/TaskExercisesCourse'; //实训考试
import LookTaskExercisesCourseDetails from '@/pages/lookCourse/TaskExercisesCourseDetails'; //实训考试详情

//资产
import AssetAllocation from '@/pages/asset/AssetAllocation'; //资产配置

//用户中心
import UserCenter from '@/pages/user/UserCenter'; //用户中心（学生端）
import TUserCenter from '@/pages/user/TUserCenter'; //用户中心（教师端）
import ThirdParty from '@/pages/user/ThirdParty'; //第三方应用
import AiTools from '@/pages/user/AiTools'; //竞赛中心
//考证信息
import Coach from '@/pages/certificate/Coach'; //考证辅导
import TCoach from '@/pages/certificate/TCoach'; //教师辅导
import CoachExam from '@/pages/certificate/CoachExam'; //考证页面
import CoachExamDetails from '@/pages/certificate/CoachExamDetails'; //考证详情
import CoachExamList from '@/pages/certificate/CoachExamList'; //考证辅导
import TCoachExamList from '@/pages/certificate/TCoachExamList'; //考证列表
import TCoachExamDetailed from '@/pages/certificate/TCoachExamDetailed'; //考证详情
import TCoachExamQuestions from '@/pages/certificate/TCoachExamQuestions'; //考证详情
import CoachErrorSet from '@/pages/certificate/CoachErrorSet'; //考证错题集
import CoachFavorites from '@/pages/certificate/CoachFavorites'; //考证收藏集
import ErrorTuckExercise from '@/pages/certificate/ErrorTuckExercise'; //错题集或者收藏夹练习页面

//竞赛
import ContestList from '@/pages/contest/ContestList'; //竞赛中心

Vue.use(Router);

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/login/',
      name: 'Login',
      component: Login,
      meta: { title: '登录',oneLogTitle:"登录", logTitle: "登录",requireAuth: false, menuShow: false,headerShow:false }
    },
    {
      path: '/',
      name: 'Home',
      component: Layout,
      redirect: '/Home',
      meta: { title: '首页',oneLogTitle:"首页",requireAuth: true},
      children: [
        {
          path: '/home/',
          name: 'Home_',
          component: Home,
          meta: { title: '首页',oneLogTitle:"首页",requireAuth: true}
        },
        {
          path: '/myApps/',
          name: 'MyApps',
          component: MyApps,
          meta: { title: '我的应用',oneLogTitle:"我的应用",  requireAuth: true}
        },
        {
          path: '/myAppsCenter/',
          name: 'MyAppsCenter',
          component: MyAppsCenter,
          meta: { title: '应用中心',oneLogTitle:"应用中心", requireAuth: true}
        },
        {
          path: '/myAppsDetails/',
          name: 'MyAppsDetails',
          component: MyAppsDetails,
          meta: { title: '应用详情',oneLogTitle:"应用中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/myAppsDetails2/',
          name: 'MyAppsDetails2',
          component: MyAppsDetails2,
          meta: { title: '应用详情',oneLogTitle:"应用中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/myCourse/',
          name: 'MyCourse',
          component: MyCourse,
          meta: { title: '我的课程',oneLogTitle:"我的课程", requireAuth: true}
        },
        {
          path: '/courseHome/',
          name: 'CourseHome',
          component: CourseHome,
          meta: { title: '课程中心',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/errorSet/',
          name: 'ErrorSet',
          component: ErrorSet,
          meta: { title: '错题集',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/exercises/',
          name: 'Exercises',
          component: Exercises,
          meta: { title: '练习页面',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/exercisesDetails/',
          name: 'ExercisesDetails',
          component: ExercisesDetails,
          meta: { title: '练习详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/taskExercisesDetails/',
          name: 'TaskExercisesDetails',
          component: TaskExercisesDetails,
          meta: { title: '实训理论考试',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/taskExercises/',
          name: 'TaskExercises',
          component: TaskExercises,
          meta: { title: '实训理论考试详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/practiceErrorTuckExercise/',
          name: 'PracticeErrorTuckExercise',
          component: PracticeErrorTuckExercise,
          meta: { title: '错题练习或收藏练习',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/homeworkStart/',
          name: 'HomeworkStart',
          component: HomeworkStart,
          meta: { title: '作业页面',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/homeworkDetails/',
          name: 'HomeworkDetails',
          component: HomeworkDetails,
          meta: { title: '作业详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/examListStart/',
          name: 'ExamListStart',
          component: ExamListStart,
          meta: { title: '考试页面',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/examListDetails/',
          name: 'ExamListDetails',
          component: ExamListDetails,
          meta: { title: '考试详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/assetAllocation/',
          name: 'AssetAllocation',
          component: AssetAllocation,
          meta: { title: '资产配置',oneLogTitle:"资产配置", requireAuth: true}
        },
        {
          path: '/courseCenter/',
          name: 'CourseCenter',
          component: CourseCenter,
          meta: { title: '课程中心',oneLogTitle:"课程中心",requireAuth: true}
        },
        {
          path: '/userCenter/',
          name: 'UserCenter',
          component: UserCenter,
          meta: { title: '用户中心',oneLogTitle:"用户中心",requireAuth: true}
        },
        {
          path: '/tUserCenter/',
          name: 'TUserCenter',
          component: TUserCenter,
          meta: { title: '用户中心',oneLogTitle:"用户中心",requireAuth: true}
        },
        {
          path: '/thirdParty/',
          name: 'ThirdParty',
          component: ThirdParty,
          meta: { title: '第三方应用',oneLogTitle:"第三方应用", requireAuth: true}
        },
        // 新增ai工具页面路由
        {
          path: '/algclargemodel/',
          name: 'algclargemodel',
          component: AiTools,
          meta: { title: 'AlGC大模型',oneLogTitle:"AlGC大模型", requireAuth: true}
        },
        {
          path: '/coach/',
          name: 'Coach',
          component: Coach,
          meta: { title: '考证辅导',oneLogTitle:"考证辅导", requireAuth: true}
        },
        {
          path: '/tCoach/',
          name: 'TCoach',
          component: TCoach,
          meta: { title: '考证辅导',oneLogTitle:"考证辅导", requireAuth: true}
        },
        {
          path: '/coachExamList/',
          name: 'CoachExamList',
          component: CoachExamList,
          meta: { title: '证券从业考试',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tCoachExamList/',
          name: 'TCoachExamList',
          component: TCoachExamList,
          meta: { title: '考证列表',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tCoachExamDetailed/',
          name: 'TCoachExamDetailed',
          component: TCoachExamDetailed,
          meta: { title: '考证详情',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tCoachExamQuestions/',
          name: 'TCoachExamQuestions',
          component: TCoachExamQuestions,
          meta: { title: '考证试题',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/coachExamDetails/',
          name: 'CoachExamDetails',
          component: CoachExamDetails,
          meta: { title: '考证详情',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/coachExam/',
          name: 'CoachExam',
          component: CoachExam,
          meta: { title: '开始考证',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/coachErrorSet/',
          name: 'CoachErrorSet',
          component: CoachErrorSet,
          meta: { title: '错题集',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/coachFavorites/',
          name: 'CoachFavorites',
          component: CoachFavorites,
          meta: { title: '收藏集',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/errorTuckExercise/',
          name: 'ErrorTuckExercise',
          component: ErrorTuckExercise,
          meta: { title: '错题集或收藏夹练习',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/courseFavorites/',
          name: 'CourseFavorites',
          component: CourseFavorites,
          meta: { title: '我的收藏',oneLogTitle:"考证辅导", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/contestList/',
          name: 'ContestList',
          component: ContestList,
          meta: { title: '竞赛中心',oneLogTitle:"竞赛中心", requireAuth: true}
        },
        {
          path: '/coursewareViewing/',
          name: 'CoursewareViewing',
          component: CoursewareViewing,
          meta: { title: '课件查看',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/scoreWeight/',
          name: 'ScoreWeight',
          component: ScoreWeight,
          meta: { title: '查看成绩权重',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/trainingIndex/',
          name: 'TrainingIndex',
          component: TrainingIndex,
          meta: { title: '查看成绩权重',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/discussionRecord/',
          name: 'DiscussionRecord',
          component: DiscussionRecord,
          meta: { title: '查看历史讨论',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tCourseHome/',
          name: 'TCourseHome',
          component: TCourseHome,
          meta: { title: '课程首页',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tMyCourse/',
          name: 'TMyCourse',
          component: TMyCourse,
          meta: { title: '我的课程',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tErrorSet/',
          name: 'TErrorSet',
          component: TErrorSet,
          meta: { title: '错题集',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tExercises/',
          name: 'TExercises',
          component: TExercises,
          meta: { title: '练习页面',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tCourseFavorites/',
          name: 'TCourseFavorites',
          component: TCourseFavorites,
          meta: { title: '我的收藏',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tCoursewareViewing/',
          name: 'TCoursewareViewing',
          component: TCoursewareViewing,
          meta: { title: '课件查看',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tScoreWeight/',
          name: 'TScoreWeight',
          component: TScoreWeight,
          meta: { title: '查看成绩权重',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tTrainingIndex/',
          name: 'TTrainingIndex',
          component: TTrainingIndex,
          meta: { title: '开始实训',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tDiscussionRecord/',
          name: 'TDiscussionRecord',
          component: TDiscussionRecord,
          meta: { title: '查看历史讨论',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/signInDetails/',
          name: 'SignInDetails',
          component: SignInDetails,
          meta: { title: '签到详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/exerciseResults/',
          name: 'ExerciseResults',
          component: ExerciseResults,
          meta: { title: '练习成绩',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/exerciseDetails/',
          name: 'ExerciseDetails',
          component: ExerciseDetails,
          meta: { title: '练习详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/questionList/',
          name: 'QuestionList',
          component: QuestionList,
          meta: { title: '试题管理',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/exportQuestion/',
          name: 'ExportQuestion',
          component: ExportQuestion,
          meta: { title: '批量导入试题',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/addPractical/',
          name: 'AddPractical',
          component: AddPractical,
          meta: { title: '新增实训',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/mp4Details/',
          name: 'Mp4Details',
          component: Mp4Details,
          meta: { title: '观看视频详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/pPTDetails/',
          name: 'PPTDetails',
          component: PPTDetails,
          meta: { title: '观看PPT频详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/theoryDetails/',
          name: 'TheoryDetails',
          component: TheoryDetails,
          meta: { title: '理论得分详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/practicalDetails/',
          name: 'PracticalDetails',
          component: PracticalDetails,
          meta: { title: '实训得分详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/reportDetails/',
          name: 'ReportDetails',
          component: ReportDetails,
          meta: { title: '报告撰写得分详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/PracticalResults/',
          name: 'PracticalResults',
          component: PracticalResults,
          meta: { title: '实操成绩',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/practicalReview/',
          name: 'PracticalReview',
          component: PracticalReview,
          meta: { title: '评阅',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/seePractice/',
          name: 'SeePractice',
          component: SeePractice,
          meta: { title: '查看实操',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/seePracticeDetails/',
          name: 'SeePracticeDetails',
          component: SeePracticeDetails,
          meta: { title: '查看实操详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/homeworkScore/',
          name: 'HomeworkScore',
          component: HomeworkScore,
          meta: { title: '查看作业成绩',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tHomeworkDetails/',
          name: 'THomeworkDetails',
          component: THomeworkDetails,
          meta: { title: '作业详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/homeworkPracticalReview/',
          name: 'HomeworkPracticalReview',
          component: HomeworkPracticalReview,
          meta: { title: '评阅作业',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/homeworkFJScore/',
          name: 'HomeworkFJScore',
          component: HomeworkFJScore,
          meta: { title: '附件作业成绩',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/examListScore/',
          name: 'ExamListScore',
          component: ExamListScore,
          meta: { title: '考试成绩',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/tExamListDetails/',
          name: 'TExamListDetails',
          component: TExamListDetails,
          meta: { title: '考试详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookCourseHome/',
          name: 'LookCourseHome',
          component: LookCourseHome,
          meta: { title: '课程首页',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookExercises/',
          name: 'LookExercises',
          component: LookExercises,
          meta: { title: '章节练习',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookExercisesDetails/',
          name: 'LookExercisesDetails',
          component: LookExercisesDetails,
          meta: { title: '练习详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookExercisesCourse/',
          name: 'LookExercisesCourse',
          component: LookExercisesCourse,
          meta: { title: '章节练习',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookExercisesCourseDetails/',
          name: 'LookExercisesCourseDetails',
          component: LookExercisesCourseDetails,
          meta: { title: '练习详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookTrainingIndex/',
          name: 'LookTrainingIndex',
          component: LookTrainingIndex,
          meta: { title: '课程实操',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookTaskExercises/',
          name: 'LookTaskExercises',
          component: LookTaskExercises,
          meta: { title: '实训理论考试',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookTaskExercisesDetails/',
          name: 'LookTaskExercisesDetails',
          component: LookTaskExercisesDetails,
          meta: { title: '实训考试详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookTaskExercisesCourse/',
          name: 'LookTaskExercisesCourse',
          component: LookTaskExercisesCourse,
          meta: { title: '实训理论考试',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
        {
          path: '/lookTaskExercisesCourseDetails/',
          name: 'LookTaskExercisesCourseDetails',
          component: LookTaskExercisesCourseDetails,
          meta: { title: '实训考试详情',oneLogTitle:"课程中心", logTitle: "logName", requireAuth: true}
        },
      ]
    },
  ]
});
let timeIn = null; // 定时器变量
let hasShownBindMobileMsg = false; // 提示标志

router.beforeEach((to, from, next) => {
  // 后端下发的菜单/应用链接是 /home/Xxx 格式（如 /home/MyApps、/home/AssetAllocation），
  // 而路由表是 /myApps/、/assetAllocation/ 等顶级路径，直接访问会整页空白（线上同样存在）。
  // vue-router 默认大小写不敏感，剥掉 /home 前缀后重新匹配即可
  if (to.matched.length === 0 && /^\/home\/.+/.test(to.path)) {
    return next({ path: to.path.replace(/^\/home/i, ""), query: to.query });
  }
  if (timeIn != null) {
    clearInterval(timeIn); // 关闭定时任务
  }
  // 每次路由跳转前都设置标题
  if (to.meta.menuShow === false) {
    window.document.title = to.meta.title || '首页';
  }
  // ✅ 每次跳转前都先重置提示标志
  hasShownBindMobileMsg = false;
  // 登录权限判断
  if (to.matched.some(m => m.meta.requireAuth)) {
    const self = Vue.prototype;
    const login = self.$getToken();
    if (!self.$isEmpty(login)) {
      setUseTask(to);
      if (from.query["_role_tag"] && !to.query["_role_tag"]) {
        to.query["_role_tag"] = from.query["_role_tag"];
        return next(to);
      }
      return next();
    } else {
      window.location.href = window.location.origin + '/Login';
      return;
    }
  }
  if (from.query["_role_tag"] && !to.query["_role_tag"]) {
    to.query["_role_tag"] = from.query["_role_tag"];
    return next(to);
  }

  return next();
});

// ✅ afterEach 中执行一次提示（只要 hasn'tShown 且没绑定手机号）
router.afterEach((to) => {
  const hasBoundMobile = localStorage.getItem("hasBoundMobile");
  if (hasBoundMobile === "false" && !hasShownBindMobileMsg) {
    Vue.prototype.$message({
      message: "请先绑定手机号",
      type: "warning"
    });
    hasShownBindMobileMsg = true; // 设置为已提示
  }
});


//定时执行使用记录方法- 每个页面都监听，根据oneLogTitle与logTitle，logTitle为空则一二级都是oneLogTitle，否则区缓存logName中的值
export function setUseTask(to) {
  if(timeIn != null){
    clearInterval(timeIn); //关闭定时
  }
  const self = Vue.prototype;
  timeIn = setInterval(()=>{ //默认一分钟调用一次
    let firstName = to.meta.oneLogTitle;
    let secondName = to.meta.logTitle;
    if(secondName == null || secondName == ""){
      secondName = firstName;
    }
    if(secondName == "logName"){
      secondName = self.$ls.get(self.$getKeyInfo("logName"));
      if(secondName == null || secondName == ""){
        secondName = firstName;
      }
    }
    let param = {
      firstName:firstName,//一级名称
      secondName:secondName,//二级名称
      useDuration:1//单次使用时长（单位：分钟）
    }
    addLog(param);
  },300000);
}

//添加使用记录
export function addLog(param) {
  const self = Vue.prototype;
  self.$postJSON('/api/studentTeacherSystemUseLogAnalysis/add.do',param).then((ret) => {
    if(ret.code == 0){
      console.log("模块定时成功！",param);
    }else{
      console.log("模块定时失败！",param);
    }
  });
}


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js